import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { FlightService } from 'src/app/services/flight.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { UserService } from 'src/app/services/user.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { UserprofileService } from 'src/app/services/userprofile.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { TripService } from 'src/app/services/trip.service';

@Component({
  selector: 'app-trip-search-request',
  templateUrl: './trip-search-request.component.html',
  styleUrls: ['./trip-search-request.component.css']
})
export class TripSearchRequestComponent {





  travelDetails = {
    travelType: 'AD',
    requestFor: 'Self',
    purpose: 'Meeting',
    tripName:'',
    userUid:'',
    createdBy:'',
    tripDescription:''

  };
uploadFile:any=''
  itineraryDetails = {
    tripType: 'oneWay',
    origin: '',
    destination: '',
    departureDate: '',
    travelTime: '',
    modeOfTravel: '',
    trainBookingType: '',
    travelClass: 'Y',
    cabHire: 'false',
    pickupDetails: '',
    hotelRequired:'Not Required'
  };

  uploadedDocument: File | null = null;
  additionalInfo = '';
file:any

  onFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.uploadedDocument = input.files[0];
     this.saveFile(this.uploadedDocument)
    }
  }
 saveFile(file: File): void {
    // You can replace this with your file upload logic (like using Angular HttpClient)
    console.log('Saving file:', file);

    // Example: Simulating a file save operation
    const reader = new FileReader();
    reader.onload = () => {
      this.file=reader.result
      // For example, you can save the file content here or upload it
      console.log('File content:', reader.result);
    };
    reader.readAsDataURL(file);  // Read the file as a base64 string (you can use other methods too)
  }
  removeDocument(): void {
    this.uploadedDocument = null;
    this.file=''
  }

  saveAsFavourite(): void {
    console.log('Saving as Favourite', this.travelDetails, this.itineraryDetails, this.additionalInfo);
  }

  saveAndContinue(): void {
    console.log('Saving and Continuing', this.travelDetails, this.itineraryDetails, this.additionalInfo);
  }

  saveAsDraft(): void {
    console.log('Saving as Draft', this.travelDetails, this.itineraryDetails, this.additionalInfo);
  }

  goBack(): void {
    console.log('Navigating Back');
  }

  flightSearchForm: FormGroup;
   airportList :any= []
  // [
  //   {
  //     name: "Goroka Airport",
  //     city: "Goroka",
  //     country: "Papua New Guinea",
  //     iataCode: "GKA",
  //   },
  //   {
  //     name: "Port Moresby Jacksons International Airport",
  //     city: "Port Moresby",
  //     country: "Papua New Guinea",
  //     iataCode: "POM",
  //   },
  //   {
  //     name: "Tofino / Long Beach Airport",
  //     city: "Tofino",
  //     country: "Canada",
  //     iataCode: "YAZ",
  //   },
  // ];
  email:any
  maxDate:any=''
  filteredAirports: Observable<any[]>[] = [];

  constructor(private TripService:TripService,private fb: FormBuilder,private renderer: Renderer2,private data:DataService,private FlightService:FlightService,private route:ActivatedRoute ,private router:Router, private cdr: ChangeDetectorRef,   private toastMsgService : ToastmsgService,private userService : UserService,
    private userInfoService : UserInfoService,private userProfileService:UserprofileService) {
      this.maxDate=new Date()
  
      this.route.queryParams.subscribe(params => {
        let data:any
        data=params
        this.email=this.userInfoService.getUsername();
       // for(let i=0 ;i <data.length; i++){ this.email +=data[i]; }
        this.getUserData();
        this.getCorporateUsers()
        this.travelDetails.userUid=this.userInfoService.getUserUuid();
        this.travelDetails.createdBy=this.userInfoService.getUserUuid()
       //this.userDataFields();
        
      
          });



      this.getFlightList()
     
    this.flightSearchForm = this.fb.group({
      travelers: [1, [Validators.required, Validators.min(1)]],
      flightSegments: this.fb.array([
        this.createFlightSegment(),
      ]),
    });

    // Initialize airport filtering for each segment
    this.flightSegments.controls.forEach((segment, index) => {
      this.initAirportFiltering(index);
    });
  }

  get flightSegments(): FormArray {
    return this.flightSearchForm.get('flightSegments') as FormArray;
  }
  date1(item:any)
  {
    const originalDate = new Date(item);
    
    const newDate = new Date(originalDate.setDate(originalDate.getDate() + 3));
    newDate.setHours(0, 0, 0, 0);
    return newDate
  } 
  dateReturn(item:any)
  {
    const originalDate = new Date(item);
    
    const newDate = new Date(originalDate.setDate(originalDate.getDate() + 4));
    // newDate.setHours(23, 59, 59, 59);
    newDate.setHours(0, 0, 0, 0);

    return newDate
  } 
  createFlightSegment(): FormGroup {
   
    return this.fb.group({
      fromAirport: ['', Validators.required],
      toAirport: ['', Validators.required],
      requestedDate:[this.date1(new Date()),Validators.required],
      returnDate:[this.dateReturn(new Date()),Validators.required],

      travelTime:[[]]
    });
  }

  addFlightSegment(): void {
    if (this.flightSegments.length < 4) {

    this.flightSegments.push(this.createFlightSegment());
    this.initAirportFiltering(this.flightSegments.length - 1);} else {
      console.log('Cannot add more than 4 flight segments');
    }
  }

  removeFlightSegment(index: number): void {
    if (this.flightSegments.length > 1) {
      this.flightSegments.removeAt(index);
      this.filteredAirports.splice(index * 2, 2); // Remove corresponding filtering
    }
  }

  initAirportFiltering(segmentIndex: number): void {
    const fromControl = this.flightSegments.at(segmentIndex).get('fromAirport');
    const toControl = this.flightSegments.at(segmentIndex).get('toAirport');

    // Set up filtering for "from" and "to" fields
    this.filteredAirports[segmentIndex * 2] = fromControl!.valueChanges.pipe(
      startWith(''),
      map(value => this.filterAirports(value || ''))
    );
    this.filteredAirports[segmentIndex * 2 + 1] = toControl!.valueChanges.pipe(
      startWith(''),
      map(value => this.filterAirports(value || ''))
    );
  }

  filterAirports(value: string): any[] {
    // const filterValue = value.toLowerCase();
    // return this.airportList.filter((airport:any) =>
    // airport.iataCode.toLowerCase().includes(filterValue)||
    //   airport.name.toLowerCase().includes(filterValue) ||
    //   airport.city.toLowerCase().includes(filterValue) 
      
    // );
    const filterValue = value.toLowerCase();
    if(filterValue!='goa'){

    // First, filter the list by iataCode
    const iataFiltered = this.airportList.filter((airport: any) =>
      airport.iataCode.toLowerCase().includes(filterValue)
    );
  
    // If no matches are found with iataCode, check name and city
    if (iataFiltered.length > 0) {
      return iataFiltered;
    }
  
    return this.airportList.filter((airport: any) =>
      // airport.name.toLowerCase().includes(filterValue) ||
      
      airport.city.toLowerCase().includes(filterValue)
    );}else{
      return this.airportList.filter((airport: any) =>
      // airport.name.toLowerCase().includes(filterValue) ||
      airport.iataCode.toLowerCase().includes(filterValue)||
      airport.city.toLowerCase().includes(filterValue)
    );
    }
  }

  onAirportSelected(event: any, field: string, segmentIndex: number): void {
    const control = this.flightSegments.at(segmentIndex).get(field);
    control?.setValue(event.option.value);
  }
  uuids:any
  travelType:any='AD'
  @Output() myOutput:EventEmitter<string>= new EventEmitter();  
  outputMessage:string="close";
 searchClick(){
    let date:any=new Date().getDate();

    // console.log(date)
    let uu:any
    // console.log(uu)

    this.uuids.push(this.generateUUIDv4())
    // console.log(this.uuids)

   
  }
  generateUUIDv4(): string {
    let date:any=new Date().getDate();
    let time:any=new Date().getTime();
    let uuidDate:any=date+time;
    // console.log(date+"t"+time)
    return uuidDate+'-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }


  onTripChange(){
 
        this.flightSegments.clear(); // Clear all flight segments
        this.filteredAirports = []; 
      this.flightSegments.push(this.createFlightSegment());
      this.initAirportFiltering(this.flightSegments.length - 1);
  }
  searchFlights(): void {
    let data:any={}
data.document=this.file
let required:boolean=true
console.log(this.cabAddress)
console.log(this.cabPickTime)
console.log(this.itineraryDetails.cabHire)

if(this.itineraryDetails.cabHire==='true'){


if(this.cabAddress&&this.cabPickTime&&this.itineraryDetails.cabHire==='true'){
  required=true
}else {
  required=false

}}
    if (this.flightSearchForm.valid&&this.travelDetails.tripName && required) {
      console.log('Flight search data:', this.flightSearchForm.value);
      // alert('Search data logged to console');
   
console.log(this.flightSearchForm.value.flightSegments)
let airSearchRequestBaseDetails:any=[]
  this.flightSearchForm.value.flightSegments.forEach((item:any)=>{
    // console.log(item?.toAirport?.split('-')[2])


   
// if(item?.toAirport?.split('-')[2]==='India'){
//   this.travelType='AD'
// }else{
//   this.travelType='AI'
// }

    let searchDetail:any={}
   
      searchDetail={
        "requestedDate": this.convertTimeZone(item?.requestedDate),
        "requestedClass": this.itineraryDetails?.travelClass,
        "fromAirport": item?.fromAirport?.split('-')[0],
        "toAirport": item?.toAirport?.split('-')[0],
        "travelTime":item?.travelTime
}

    

airSearchRequestBaseDetails.push(searchDetail)
  })
  const from = this.flightSearchForm.value.flightSegments.some((item:any) => item?.toAirport?.split('-')[2] === 'India');
  const to = this.flightSearchForm.value.flightSegments.some((item:any) => item?.toAirport?.split('-')[2] === 'India');
  if(from&&to){
    this.travelDetails.travelType='AD'
   }else{
    this.travelDetails.travelType='AI'

   }
// console.log(this.travelDetails)
// console.log(this.itineraryDetails)
// console.log(this.uploadedDocument)
let data:any={}

if(this.itineraryDetails.tripType==='return'){
  let count:any=1
  let totalCount:any=1

  if(this.onBehalf.length>0){
    count=this.onBehalf.length
    totalCount=this.onBehalf.length

  }
  if(this.otherList.length>0){
    count=this.selectedAdults
    totalCount=this.selectedAdults+this.selectedChildren+this.selectedInfants

  }
  
   data={
    
    "airSearchRequestBaseDetails": [{
      "requestedDate":airSearchRequestBaseDetails[0]?.requestedDate,
      "requestedClass": airSearchRequestBaseDetails[0]?.requestedClass,
      "fromAirport": airSearchRequestBaseDetails[0]?.fromAirport,
      "toAirport": airSearchRequestBaseDetails[0]?.toAirport,
      "travelTime": airSearchRequestBaseDetails[0]?.travelTime

  },
  {
    "requestedDate": this.convertTimeZone(this.flightSearchForm.value.flightSegments[0]?.returnDate),
    "requestedClass": airSearchRequestBaseDetails[0]?.requestedClass,
    "fromAirport": airSearchRequestBaseDetails[0]?.toAirport,
    "toAirport": airSearchRequestBaseDetails[0]?.fromAirport,
    "travelTime": airSearchRequestBaseDetails[0]?.travelTime

}] ,
    "journeyType":this.itineraryDetails.tripType,
    "paxCount": totalCount,
    "adultCount": count,
    "childCount": this.selectedChildren,
    "infantCount": this.selectedInfants,
}

this.uuids=this.generateUUIDv4()
data.requestId=this.uuids
data.uuid=this.uuids
data.cabHire=this.itineraryDetails.cabHire
data.hotelRequired=this.itineraryDetails.hotelRequired

data.travelType=this.travelDetails.travelType
data.pointerEvents=true
data.onBehalf=this.onBehalf
data.otherList=this.otherList
data.cabLocation=this.cabLocation
data.cabAddress=this.cabAddress
data.cabPickUpTime=this.cabPickTime
data.hotelLocation=this.hotelLocation
data.requestFor=this.travelDetails.requestFor
this.data.deliverMsg(data)

this.myOutput.emit(this.outputMessage);
data.document=this.file||''

this.createTrip(data)

// if(this.travelDetails.travelType==='AI'){
//   this.router.navigate(["/app/flight-intl-list"]);

// }else{
//   this.router.navigate(["/app/flightList"]);

// }

}else if(this.itineraryDetails.tripType==='multiCity'){


  let count:any=1
  let totalCount:any=1


if(this.onBehalf.length>0){
  count=this.onBehalf.length
  totalCount=this.onBehalf.length

}
if(this.otherList.length>0){
  count=this.selectedAdults
  totalCount=this.selectedAdults+this.selectedChildren+this.selectedInfants

}


// convertTimeZone
    data={
    
      "airSearchRequestBaseDetails": airSearchRequestBaseDetails,
      "journeyType":this.itineraryDetails.tripType,
      "paxCount": totalCount,
      "adultCount": count,
      "childCount": this.selectedChildren,
      "infantCount": this.selectedInfants,
  }
  this.uuids=this.generateUUIDv4()
  data.requestId=this.uuids
  data.uuid=this.uuids
  data.cabHire=this.itineraryDetails.cabHire
  data.hotelRequired=this.itineraryDetails.hotelRequired

  data.travelType=this.travelDetails.travelType
  data.pointerEvents=true
  data.requestFor=this.travelDetails.requestFor
  

  data.onBehalf=this.onBehalf 
  data.otherList=this.otherList
  data.cabLocation=this.cabLocation
  data.cabAddress=this.cabAddress
data.cabPickUpTime=this.cabPickTime
  data.hotelLocation=this.hotelLocation
  this.data.deliverMsg(data)

  this.myOutput.emit(this.outputMessage);
  data.document=this.file||''

  this.createTrip(data)

  // if(this.travelDetails.travelType==='AI'){
  //   this.router.navigate(["/app/flight-intl-list"]);

  // }else{
  //   this.router.navigate(["/app/flightList"]);

  // }

}else if(this.itineraryDetails.tripType==='oneWay'){
  let count:any=1
  let totalCount:any=1

if(this.onBehalf.length>0){
  count=this.onBehalf.length
  totalCount=this.onBehalf.length

}
if(this.otherList.length>0){
  count=this.selectedAdults
  totalCount=this.selectedAdults+this.selectedChildren+this.selectedInfants

}

    data={
    
      "airSearchRequestBaseDetails": airSearchRequestBaseDetails,
      "journeyType":this.itineraryDetails.tripType,
      "paxCount": totalCount,
      "adultCount": count,
      "childCount": this.selectedChildren,
      "infantCount": this.selectedInfants,
  }
  this.uuids=this.generateUUIDv4()
  data.requestId=this.uuids
  data.uuid=this.uuids
  data.cabHire=this.itineraryDetails.cabHire
  data.hotelRequired=this.itineraryDetails.hotelRequired
  data.cabAddress=this.cabAddress
  data.cabPickUpTime=this.cabPickTime
  data.requestFor=this.travelDetails.requestFor
  data.onBehalf=this.onBehalf 
  data.travelType=this.travelDetails.travelType
data.pointerEvents=true
data.otherList=this.otherList
data.cabLocation=this.cabLocation
data.hotelLocation=this.hotelLocation
  this.data.deliverMsg(data)
  
  this.myOutput.emit(this.outputMessage);
  data.document=this.file||''

  this.createTrip(data)
    // this.router.navigate(["/app/flightlist"]);

  }

} else {
  alert('Please fill all required fields.');
}
 
  }


  getFlightList() {

    this.FlightService
      .getFlightList()
      .subscribe({
        next: (res: any) => {
          if (res) {
            let data: any;
            data = res
            // let mappedDataWithIataCode:Map<String,any>=new Map<String,any>();
            
            //  data.forEach(({iataCode,...rest})=>{
            //   mappedDataWithIataCode.set(iataCode,rest);
            //  });
            this.airportList=data;
           
           

          } else {
          }
        }, error: (err) => {


        }
      }
      )
  }
  minData=new Date()


  showSpinners = true;        // Show spinners for time input
  showSeconds = true;         // Allow seconds input
  stepHour = 1;               // Hour step
  stepMinute = 1;             // Minute step
  stepSecond = 1;             // Second step
  touchUi = false;            // Show in touch UI mode
  color: 'primary' | 'accent' | 'warn' = 'primary'; // Date picker color
  enableMeridian = false;      // 12-hour format (AM/PM)
  disableMinute = false;      // Enable/disable minute input
  hideTime = true;           // Hide time portion of the picker
  disabled = false;  



  timeRangeDisplay: string = ''; // Display value for the input
  fromTime: string = ''; // Selected "From" time
  toTime: string = ''; // Selected "To" time
  timePickerDialogVisible: boolean = false;

  // Open the time range dialog
  openTimeRangeDialog() {
    this.timePickerDialogVisible = true;
  }

  // Close the time range dialog
  closeTimeRangeDialog() {
    this.timePickerDialogVisible = false;
  }

  // Save the time range and update the display value
  saveTimeRange() {
    this.timeRangeDisplay = `${this.fromTime} - ${this.toTime}`;
    this.closeTimeRangeDialog();
  }
  convertTimeZone(input:any){
    console.log()
    const inputDateTime = input;
    const datePipe = new DatePipe('en-IN');
  
    let formattedDateTime:any = datePipe.transform(inputDateTime, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
    console.log(formattedDateTime)
  
    return formattedDateTime;
  }

  usersList:any=[]
  travellerTo:any=[]
  filteredTo!: Observable<any[]>;
  traveller = new FormControl('');

  getCorporateUsers(){
   
    this.userProfileService
    .getCorporateUserList()
    .subscribe({
      next : (res:any) => {
        if(res) {
         
         let data:any
         data=res  
         this.usersList=data
        this.usersList=this.usersList.filter((item:any) => item.userBookingProfile.firstName && item.userBookingProfile.firstName.trim() !== '');
        this.filterTraveller()
        //  this.travellerTo=this.usersList
        //  this.filteredTo = this.traveller.valueChanges.pipe(
        //   // debounceTime(300), // Adjust the debounce time as needed
        //   //distinctUntilChanged(),
        //   startWith(null),
        //   map((item: any | null) => (item ? this._filter(item) : this.travellerTo.slice())),
        // );

        } else {    
        } 
      },error : (err) => {

        
      }
    }
  )
  }

   searchQuery:any=""
onBehalf:any=[]
otherList:any=[]

   filteredUserGroup: any[] = [...this.usersList]; // Clone the original data
userList:any=[]
// Function to filter the entities based on the search query
filterTraveller() {

  this.filteredUserGroup= this.usersList.filter((item:any) =>
    item.userBookingProfile.firstName.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())||
    item.userBookingProfile.username.toLowerCase().trim().includes(this.searchQuery.toLowerCase().trim())

  );

}
onRequestChange(){
  this.userList=[]
  this.onBehalf=[]
  this.selectedAdults = 1;
  this.selectedChildren = 0;
  this.selectedInfants = 0;
  
  this.otherList=[]
  if(this.travelDetails.requestFor==='Other'){
    this.selectAdults(this.selectedAdults)
  }
}
onChangeTraveller(){

  this.userList=this.usersList.filter((item:any)=>this.onBehalf.includes(item.userUid))

}

  private _filter(value: any): any[] {
    // console.log(value)
     const filterValue = value.toLowerCase();
    
     return this.travellerTo.filter((item:any) => item.username.toLowerCase().includes(filterValue));
   }

   
   travellerName:any
   separatorKeysCodesTo: number[] = [ENTER, COMMA];

   @ViewChild('travellerInput') travellerInput!: ElementRef<HTMLInputElement>;
   addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.travellerName.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.traveller.setValue(null);
  }
   selectedTo(event: MatAutocompleteSelectedEvent): void {

    this.travellerName=event.option.viewValue;

    this.travellerInput.nativeElement.value = event.option.viewValue;
  
    
     
    this.traveller.setValue(null);
  
  }
  userInformation:any
  approver:any=''
  getUserData(){
    this.userService.getUserData(this.email)
    .subscribe({
      next : (res:any) => {
        if(res) {
   let data:any
   data=res
 this.userInformation=data
  this.getUserByUUid()
        } else {    
        } 
      },error : (err) => {
  
        console.error("Error in fetching data");
      }
    }
  )
  }
  getUserByUUid(){
 
    this.userService.getUserbyUUid(this.userInformation?.userBookingProfile?.supervisorCodes)
    .subscribe({
      next : (res:any) => {
        if(res) {
          this.approver=res?.name||''
  
        } else {
        } 
      },error : (err) => {
      }
    }
  )
  
  
  }

  ngOnInit() {
    

    // Initialize example rows
    for (let i = 0; i < 3; i++) {
      this.addTravelTime();
    }
   
  }

  onChangeCabHire(){
    if(this.itineraryDetails.cabHire==='true'){

    setTimeout(() => {
this.getPlaceAutoCabcomplete()
    }, 500);}else{
      this.cabLocation=''
      this.cabAddress=''
      this.cabPickTime=''
    }

  }
  onChangeHotelRequired(){
 

    if(this.itineraryDetails.hotelRequired==='true'){

      setTimeout(() => {
        this.getPlaceAutocomplete();

      }, 500);}else{
      this.hotelLocation=''
      }
  }

  get travelTimes(): FormArray {
    return this.flightSegments.get('travelTimes') as FormArray;
  }
  timeRange: string[] = [];

  addTravelTime() {
    // this.travelTimes.push(this.fb.control(''));
    this.timeRange.push('Select Time');
  }

  setTime(event: string, index: number, type: 'from' | 'to',segment:any) {
    if (type === 'from') {
      this.timeRange[index] = `${event} - ...`;
      setTimeout(() => this.openTimePicker(index, 'to'), 300); // Open 'To' picker after 'From' is selected
      segment.value.travelTime= `${event} - ...`
    } else {
      this.timeRange[index] = this.timeRange[index].replace('- ...', `- ${event}`);
      segment.value.travelTime= this.timeRange[index].replace('- ...', `- ${event}`)
      console.log(  this.travelTimes)
      // this.travelTimes.at(index).setValue(this.timeRange[index]);
    }
  }

  openTimePicker(index: number, type: 'from' | 'to') {
    const picker = document.querySelector<HTMLElement>(type === 'from' ? `#fromPickerRefs-${index}` : `#toPickerRefs-${index}`);
    if (picker) picker.click();
  }

  tripDisabled:boolean=false
  createTrip(data:any) {
    
    this.tripDisabled=true
    let request:any={
      "tripName":this.travelDetails.tripName,
    "tripDescription":this.travelDetails.tripDescription,
    "tripFor": this.travelDetails.requestFor,
    "tripPurpose": this.travelDetails.purpose,
    "userUid":this.travelDetails.userUid,
    "createdBy":this.travelDetails.createdBy,
      tripDetails:data
    }
   
     this.TripService
     .saveTrip(request)
     .subscribe({
       next : (res:any) => {
         this.tripDisabled=false
  
 let data:any
 data=res.body
  //  this.tripRequest.userUid=this.userInfoService.getUserUuid();
  //    this.tripRequest.createdBy=this.userInfoService.getUserUuid()
 
         this.toastMsgService.setMsg({msg : "Success!",msgTitle : "Success", msgType : "I"});
       //  location.reload()


       if(data.statuss==='Success') {
        let request:any

         request={
          activeTripUid:data?.tripUid,
          userUid:this.travelDetails.userUid,
         }
       
        this.activeList(request)
      }else{


        this.toastMsgService.setMsg({msg : "Failed",msgTitle : "Warning", msgType : "W"});

        }
         
        
        
       },error : (err) => {
         this.tripDisabled=false
 
         this.toastMsgService.setMsg({msg : "Failed",msgTitle : "Warning", msgType : "W"});
   
       }
     }
   )
   
     // Logic for trip creation goes here.
   }



   activeList(item:any){
   
    this.TripService
    .activeTrip(item)
    .subscribe({
      next : (res:any) => {
        if(this.itineraryDetails.tripType==='return'){

          if(this.travelDetails.travelType==='AI'){
            this.router.navigate(["/app/flight-intl-list"]);
          
          }else{
            this.router.navigate(["/app/flightList"]);
          
          }}
  
           if(this.itineraryDetails.tripType==='multiCity'){
            if(this.travelDetails.travelType==='AI'){
              this.router.navigate(["/app/flight-intl-list"]);
          
            }else{
              this.router.navigate(["/app/flightList"]);
          
            }
  
          }
  
          if(this.itineraryDetails.tripType==='oneWay'){
            this.router.navigate(["/app/flightlist"]);
  
          }
          this.tripDisabled=false

        // if(res) {
        //   const data = res

        //  } else {

        //  } 
      },error : (err) => {
        this.tripDisabled=false

        // console.error("Error in fetching all getRoleList");
      }
    }
  )
  }


  adults = [0,1, 2, 3, 4, 5, 6, 7, 8, 9];
  children = [0,1, 2, 3, 4, 5, 6, 7, 8, 9];
  infants = [0,1, 2, 3, 4, 5, 6, 7, 8, 9];
  // travelClasses = ['Economy/Premium Economy', 'Premium Economy', 'Business', 'First Class'];

  selectedAdults = 1;
  selectedChildren = 0;
  selectedInfants = 0;
  // selectedClass = this.travelClasses[0];

  selectAdults(num: any) { 
    this.selectedAdults = num; 
    let adt = this.PassengersArray(this.selectedAdults);
    let chd = this.PassengersCArray(this.selectedChildren);
    let inf = this.PassengersIArray(this.selectedInfants);
  
    // Create deep copies to prevent shared references
    this.otherList = [...adt, ...chd, ...inf].map(obj => ({
      ...obj // Spread each object to create a new instance
    }));
  }
  selectChildren(num: any) { 
    this.selectedChildren = num;
    let adt = this.PassengersArray(this.selectedAdults);
    let chd = this.PassengersCArray(this.selectedChildren);
    let inf = this.PassengersIArray(this.selectedInfants);
  
    // Create deep copies to prevent shared references
    this.otherList = [...adt, ...chd, ...inf].map(obj => ({
      ...obj // Spread each object to create a new instance
    }));
   }
  selectInfants(num: any) {
     this.selectedInfants = num; 
    
     let adt = this.PassengersArray(this.selectedAdults);
     let chd = this.PassengersCArray(this.selectedChildren);
     let inf = this.PassengersIArray(this.selectedInfants);
   
     // Create deep copies to prevent shared references
     this.otherList = [...adt, ...chd, ...inf].map(obj => ({
       ...obj // Spread each object to create a new instance
     }));
    }
  // selectClass(cls: string) { this.selectedClass = cls; }
  

  PassengersArray(item:any){
    // console.log(item)
   
  let detail:any={title:'',firstName:'',lastName:'',email:'',mobile:'',passengerType:'ADT',justification:'',organization:'',isGov:false}
    let Passengers=[]
    if(item){for(let i=0;i<item;i++){
  Passengers.push(detail)
    }}
    return Passengers
  }
  PassengersCArray(item:any){
    // console.log(item)
   
  let detail:any={title:'',firstName:'',lastName:'',email:'',mobile:'',passengerType:'CHD'}
    let Passengers=[]
    if(item){for(let i=0;i<item;i++){
  Passengers.push(detail)
    }}
    return Passengers
  }
  cancelOtherData(item:any){
if (item > 0) { 
  this.otherList.splice(item, 1); // Remove item if it's not the first one
}
let adult:any=this.otherList.filter((item:any)=>item.passengerType==='ADT')
let child:any=this.otherList.filter((item:any)=>item.passengerType==='CHD')
let inf:any=this.otherList.filter((item:any)=>item.passengerType==='INF')
this.selectedAdults = adult.length;
this.selectedChildren = child.length;
this.selectedInfants = inf.length;
  }
  PassengersIArray(item:any){
    // console.log(item)
   
  let detail:any={title:'',firstName:'',lastName:'',email:'',mobile:'',passengerType:'INF'}
    let Passengers=[]
    if(item){for(let i=0;i<item;i++){
  Passengers.push(detail)
    }}
    return Passengers
  }
  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }
  test(){
    console.log(this.otherList)
  }
  // onClickApply(){
  //   let adt = this.PassengersArray(this.selectedAdults);
  //   let chd = this.PassengersCArray(this.selectedChildren);
  //   let inf = this.PassengersIArray(this.selectedInfants);
  
  //   // Create deep copies to prevent shared references
  //   this.otherList = [...adt, ...chd, ...inf].map(obj => ({
  //     ...obj // Spread each object to create a new instance
  //   }));
  // }

  @Input() adressType: any;
@Output() setAddress: EventEmitter<any> = new EventEmitter();
@ViewChild('addresstextInput') addresstextInput: any;
addresstextValue: any = '';


autocompleteInput: any;
  pickUpLocation:any;
  dropOffLocation:any;
  location: any="kempegowda International Airport, Bengaluru, Karnataka, India.";
 
 
  lat:any;
  long:any;
  pickUpLat:any;
  pickUpLong:any;
  private getPlaceAutocomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addresstextInput.nativeElement, {
      componentRestrictions: { country: 'IND' },
      types: [this.adressType]
    });

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeEvent(place);
    });
  }
  hotelLocation:any=''
  cabLocation:any=''
  cabAddress:any=''
  cabPickTime:any=''

  invokeEvent(place: any) {
    this.pickUpLocation = place.formatted_address as any; 
    this.pickUpLat=place.geometry.location.lat();
    this.pickUpLong=place.geometry.location.lng();
    
    this.hotelLocation=this.pickUpLocation+'#Latitude:'+place.geometry.location.lat()+'#Longitude:'+place.geometry.location.lng()
console.log(this.hotelLocation)
    // this.combineFilters()
 

    // this.setAddress.emit(place);

  }


  @Input() adressCabType: any;
  @Output() setCabAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addressCabtextInput') addressCabtextInput: any;
 addressCabtextValue: any = '';
 autocompleteCabInput: any;
  pickcabLocation:any;
  dropOffcabLocation:any;
  locationCab: any="kempegowda International Airport, Bengaluru, Karnataka, India.";
 
 
  latCab:any;
  longCab:any;
  pickUpLatCab:any;
  pickUpLongCab:any;
  private getPlaceAutoCabcomplete() {
    const autocomplete = new google.maps.places.Autocomplete(this.addressCabtextInput.nativeElement, {
      componentRestrictions: { country: 'IND' },
      types: [this.adressCabType]
    });

    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      this.invokeCabEvent(place);
    });
  }

  invokeCabEvent(place: any) {
    this.pickcabLocation = place.formatted_address as any; 
    this.pickUpLatCab=place.geometry.location.lat();
    this.pickUpLongCab=place.geometry.location.lng();
   this.cabLocation=this.pickcabLocation+'#Latitude:'+place.geometry.location.lat()+'#Longitude:'+place.geometry.location.lng()
    // this.combineFilters()
    // this.setCabAddress.emit(place);
// console.log(this.setCabAddress)
// console.log(this.cabLocation)

  }


 
}





  

